import { createUseStyles } from 'react-jss'
import { colors } from '../../../variables.style'
import { style as filterStyle } from '../filter.style'

export const style = {
  actions: {
    paddingTop: '25px',
    gridColumn: -2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  container: {
    marginBottom: 10
  },
  borderedFilterContainer: {
    border: `1px solid ${colors.borderGray}`,
    borderRadius: '4px'
  },
  applyButton: {
    alignSelf: 'flex-end',
    marginLeft: 10
  },
  downCaret: {
    fontSize: 12,
    marginLeft: 7,
    position: 'relative',
    paddingBottom: '2px'
  },
  controlGrid: {
    ...filterStyle.controlGrid,
    paddingTop: 0
  },
  controlCol: filterStyle.controlCol,
  controlColSpan2: filterStyle.controlColSpan2,
  control: filterStyle.control,
  controlLabel: filterStyle.controlLabel,
  slider: filterStyle.slider
}

export const useStyles = createUseStyles(style)
